if (!customElements.get("product-markdown-tables")) {
  const isSeparator = (line) => /^\|[\s\-:|]+\|$/.test(line);

  const parseCells = (line) => {
    const cells = line
      .split("|")
      .slice(1, -1)
      .map((cell) => cell.trim());
    return cells.length ? cells : null;
  };

  const buildTable = (headerCells, bodyCells) => {
    const table = document.createElement("table");
    table.className = "main-product-accordion__table";

    const thead = table.createTHead();
    for (const cells of headerCells) {
      const tr = thead.insertRow();
      for (const cell of cells) {
        const th = document.createElement("th");
        th.textContent = cell;
        tr.appendChild(th);
      }
    }

    if (bodyCells.length) {
      const tbody = table.createTBody();
      for (const cells of bodyCells) {
        const tr = tbody.insertRow();
        for (const cell of cells) tr.insertCell().textContent = cell;
      }
    }

    return table;
  };

  const parseParagraph = (p) => {
    if (!p.textContent.includes("|")) return;

    const lines = p.innerHTML
      .replace(/<br\s*\/?>\s*/gi, "\n")
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);

    const groups = [];
    let current = [];
    for (const line of lines) {
      if (line.startsWith("|") && line.endsWith("|")) {
        current.push(line);
      } else {
        if (current.length >= 2) groups.push({ lines: [...current] });
        current = [];
      }
    }
    if (current.length >= 2) groups.push({ lines: [...current] });
    if (!groups.length) return;

    const fragment = document.createDocumentFragment();
    const allTableLines = new Set(groups.flatMap((group) => group.lines));
    let builtAny = false;

    let i = 0;
    while (i < lines.length) {
      const line = lines[i];
      const group = groups.find((g) => g.lines[0] === line && i === lines.indexOf(line));

      if (group) {
        let headerLines = [];
        let bodyLines = [];
        let foundSeparator = false;

        for (const groupLine of group.lines) {
          if (!foundSeparator && isSeparator(groupLine)) {
            foundSeparator = true;
            continue;
          }
          if (foundSeparator) bodyLines.push(groupLine);
          else headerLines.push(groupLine);
        }

        if (!foundSeparator) {
          headerLines = [group.lines[0]];
          bodyLines = group.lines.slice(1);
        }

        const headerCells = headerLines.map(parseCells);
        const bodyCells = bodyLines.map(parseCells);

        if (headerCells.some((cells) => !cells) || bodyCells.some((cells) => !cells)) {
          i++;
          continue;
        }

        const columnCount = headerCells[0].length;
        const consistent = [...headerCells, ...bodyCells].every((cells) => cells.length === columnCount);
        if (!consistent || columnCount === 0) {
          i++;
          continue;
        }

        fragment.appendChild(buildTable(headerCells, bodyCells));
        builtAny = true;
        i += group.lines.length;
        continue;
      }

      if (!allTableLines.has(line)) {
        const paragraph = document.createElement("p");
        paragraph.innerHTML = line;
        fragment.appendChild(paragraph);
      }
      i++;
    }

    if (builtAny && fragment.childNodes.length) p.replaceWith(fragment);
  };

  customElements.define(
    "product-markdown-tables",
    class ProductMarkdownTables extends HTMLElement {
      connectedCallback() {
        this.parentElement
          .querySelectorAll("[data-markdown-tables]:not([data-markdown-tables='parsed'])")
          .forEach((container) => {
            if (container.textContent.includes("|")) {
              container.querySelectorAll("p").forEach((p) => {
                try {
                  parseParagraph(p);
                } catch (_) {
                  // Leave a paragraph that fails to parse as it was.
                }
              });
            }
            container.dataset.markdownTables = "parsed";
          });
      }
    },
  );
}
